import { h } from 'preact'
import logoJo2024 from './logo-paris-2024-orange-pere-noel.png'

export const JeuJo2024 = ({ CTA }) => {
   return (
      <div class="jeu-jo-2024 lien-composite mb-2 mb-md-4 pt-1 pb-2 py-md-0" data-testid="bande-jeu-jo-2024">
         <div class="container-fluid">
            <div class="row">
               <div class="col-12 col-md-6 order-md-2 bloc-image">
                  <img src={logoJo2024} alt="Paris 2024 - Orange Partenaire Premium" loading="lazy" />
               </div>
               <div class="col-12 col-md-6 order-md-1 position-static">
                  <div class="bloc-text">
                     <h2 class="h3 mb-0 mb-md-1">
                        Tentez de gagner vos billets pour{' '}
                        <span class="text-primary">
                           Paris&nbsp;2024<sup>*</sup>
                        </span>
                     </h2>
                     <p class="h3 mb-1 mb-md-2">Bonne chance !</p>
                     <a
                        href={CTA.URL}
                        class="btn btn-primary"
                        data-oevent-category={CTA.analytics.oeventCategory}
                        data-oevent-action={CTA.analytics.oeventAction}
                        data-oevent-label={CTA.analytics.oeventLabel}
                        data-oevent-other={CTA.analytics.oeventOther}
                     >
                        {CTA.label}
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}
